import { render, staticRenderFns } from "./ed-link-viewer.vue?vue&type=template&id=1a5b41e8&scoped=true&"
import script from "./ed-link-viewer.ts?vue&type=script&lang=js&"
export * from "./ed-link-viewer.ts?vue&type=script&lang=js&"
import style0 from "./ed-link-viewer.scss?vue&type=style&index=0&id=1a5b41e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5b41e8",
  null
  
)

export default component.exports